import { COMMUNITY_RENTAL_TYPE } from 'constants/rentalTypes';

const componentToHex = (c: number) => {
  const hex = c.toString(16);
  return hex.length == 1 ? '0' + hex : hex;
};

export const generatePastelColor = () => {
  // Generate random RGB values for a pastel color
  let r = Math.floor(Math.random() * 256);
  let g = Math.floor(Math.random() * 256);
  let b = Math.floor(Math.random() * 256);

  // Calculate the average to create a pastel effect
  r = Math.floor((r + 255) / 2);
  g = Math.floor((g + 255) / 2);
  b = Math.floor((b + 255) / 2);

  // Convert RGB to hexadecimal
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
};

export const groupByApartmentId = (data: any[]) => {
  const groups: any = {};

  data.forEach(function (val) {
    const category = val.Combination_Id;
    if (category) {
      if (category in groups) {
        groups[category].push(val);
      } else {
        groups[category] = new Array(val);
      }
    }
  });
  return groups;
};

export const isCommunityCCRC = (rentalTypes: any[]) => {
  if (!rentalTypes || rentalTypes.length === 0) {
    return false;
  }
  return rentalTypes.some((rt) => rt.type === COMMUNITY_RENTAL_TYPE.CCRC);
};

export const isCompetitorCCRC = (competitor: any) =>
  Array.isArray(competitor?.rental_types) &&
  competitor.rental_types.some((rentalType: any) => rentalType?.type === COMMUNITY_RENTAL_TYPE.CCRC);

export const hasAnyCCRCCompetitor = (competitors: any[]) =>
  Array.isArray(competitors) && competitors.some(isCompetitorCCRC);
